import React from 'react';
import Accordion from './Accordion/Accordion';
import { useTranslation } from 'react-i18next';

export default function ServicesDev() {

  const { t } = useTranslation();
  
  return (
    <section className='serv-dev sec--area'>
      <div class="container">
        <div className='my-5 '>
          <h2 className=" line-break w_color f_700 z-index99 text-center">
            {t("serv_dev.title")}
          </h2>
        </div>
          <div className='accordion-area'>
            <Accordion
              title={t("serv_dev.serv_app")}
              description={t("serv_dev.serv_app_descrip")} />
            <Accordion
              title={t("serv_dev.serv_web")}
              description={t("serv_dev.serv_web_descrip")} />
            <Accordion
              title={t("serv_dev.serv_org")}
              description={t("serv_dev.serv_org_descrip")} />
            <Accordion
              title={t("serv_dev.serv_system")}
              description={t("serv_dev.serv_system_descrip")} />

          </div>

          <div className='text-center mt-3'>
            <a href='#Formulario' className="mt-4 btn_booking">{t("form_booking_btn")}</a>
          </div>
      </div>
    </section>
  )
}

